// extracted by mini-css-extract-plugin
export default {"container":"AddNewProject-module__container___T002z","hasNoProjects":"AddNewProject-module__hasNoProjects____gWAY"};